import { Directive, ElementRef, HostBinding, OnInit, Self } from '@angular/core';

import { CompanyService } from '@app/shared/services/company.service';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';
import { takeUntil } from 'rxjs/operators';
import { BACKGROUND_GRADIENT } from '@constants';

@Directive({
  providers: [NgOnDestroy],
  selector: '[appBackgroundBranded]',
  standalone: false
})
export class BackgroundBrandedDirective implements OnInit {
  @HostBinding('class') class = 'background-branded';

  constructor(
    @Self() private destroy: NgOnDestroy,
    private companyService: CompanyService,
    private elmRef: ElementRef<HTMLDivElement>
  ) {}

  ngOnInit(): void {
    const element = this.elmRef.nativeElement;

    this.companyService.data$.pipe(takeUntil(this.destroy)).subscribe(data => {
      const branding = data.registrationPageBranding;
      const isBgSet = Boolean(branding.backgroundImage);
      element.style.backgroundImage = isBgSet ? `url("${branding.backgroundImage.href}")` : BACKGROUND_GRADIENT;
    });
  }
}
